<div class="v4-layout-field" [class.focus]="active()">
  <div
    class="v4-layout-field-label first flex flex-row items-center justify-between flex-1 cursor-pointer"
    nz-popover
    nzPopoverTrigger="hover"
    [nzPopoverContent]="houseOverview"
    nzPopoverPlacement="left">
    <div class="flex flex-row items-center">
      <!-- <span
        class="pay-type"
        [class.cash]="entity().thirdparty_type === Platform.Ctrip && data().payment_type === 1"
        [class.advance]="entity().thirdparty_type === Platform.Ctrip && data().payment_type === 0"></span> -->
      <img
        class="channel-wrap mr-1"
        [src]="(entity().thirdparty_type | thirdparty)?.icon_color"
        style="width: 20px; height: 20px" />
      <div class="title-wrap leading-tight">
        <p
          class="house-title"
          nz-paragraph
          [nzEllipsis]="true"
          [nzEllipsisRows]="entity().thirdparty_type === Platform.Ctrip ? 1 : 2">
          {{ entity()?.thirdparty_house_title }}
        </p>
      </div>

      <ng-template #houseOverview>
        <div class="house-overview-content">
          <div class="flex flex-row items-center">
            <img
              src="/assets/status/placeholder.png"
              hostPlaceholder
              [delaySrc]="entity()?.c_cover_url"
              alt=""
              class="w-[60px] h-[40px] mr-[12px] rounded" />
            <div class="max-w-[250px]">
              <div class="flex flex-row items-center">
                <a [href]="entity()?.housing_link" target="_blank" class="text-m ellipsis-line-2">{{
                  entity()?.thirdparty_house_title
                }}</a>
              </div>

              <div class="flex flex-row items-center">
                <img
                  class="w-[16px] h-[16px] rounded-full"
                  [attr.src]="(entity().thirdparty_type | thirdparty)?.icon_color" />
                <span class="text-s ml-1">{{ entity()?.account_username }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="v4-layout-field-control !flex-none w-[120px]">
    <div class="v4-layout-field-row w-full justify-end">
      <label
        class="v4-checkbox-light"
        nz-checkbox
        [(ngModel)]="data().checked"
        (ngModelChange)="onCheckChange.emit($event)"
        [nzDisabled]="disabled()"
        nz-popover
        [nzPopoverTrigger]="disabled() ? 'hover' : null"
        [nzPopoverTitle]="null"
        [nzPopoverContent]="ratePlanWarnTpl"
        >{{ "word.copy" | translate }}</label
      >
      <ng-template #ratePlanWarnTpl>
        <span class="text-m">{{ "price-calendar_html_rate_plan_click_disabeld_tip" | translate }}</span>
      </ng-template>
    </div>
  </div>
</div>
